"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorCodeDoesNotExistException_1 = __importDefault(require("./exceptions/ErrorCodeDoesNotExistException"));
var ErrorNameDoesNotExistException_1 = __importDefault(require("./exceptions/ErrorNameDoesNotExistException"));
var errors_json_1 = __importDefault(require("./errors.json"));
var ErrorCodeHelper = /** @class */ (function () {
    function ErrorCodeHelper() {
    }
    ErrorCodeHelper.getMapping = function () { return errors_json_1.default; };
    ErrorCodeHelper.getCodeByName = function (name) {
        if (!errors_json_1.default[name]) {
            throw new ErrorNameDoesNotExistException_1.default(name);
        }
        return errors_json_1.default[name];
    };
    ErrorCodeHelper.getNameByCode = function (code) {
        var errorKeys = Object.keys(errors_json_1.default);
        var name = errorKeys.find(function (key) { return (errors_json_1.default[key] === code); });
        if (!name) {
            throw new ErrorCodeDoesNotExistException_1.default(code);
        }
        return name;
    };
    return ErrorCodeHelper;
}());
exports.default = ErrorCodeHelper;
//# sourceMappingURL=ErrorCodeHelper.js.map